"use client";

import classNames from "classnames";
import RivalsBullet from "rivals/components/shared/Icons/RivalsBullet";
import RivalsSquareIcon from "rivals/components/shared/Icons/RivalsSquareIcon";
import Link from "rivals/components/shared/Link";
import { PATHS } from "rivals/shared/constants";
import { setData } from "rivals/shared/utils/qa";
import colors from "rivals/styles/exports.module.scss";
import styles from "./Paywall.module.scss";
import strings from "./strings";
import { PAYWALL_VARIANT, Props } from "./types";

const DATA_PHILTER = "premium-paywall";
const { bullets, goBig, logIn, subscribe } = strings;

function Paywall({
  isNational,
  variant = PAYWALL_VARIANT.ARTICLE,
  primaryColor,
  title = subscribe
}: Props): React.JSX.Element {
  const isGallery = variant === PAYWALL_VARIANT.GALLERY;
  const bulletColor = isNational ? colors.hoops : `#${primaryColor}`;
  const buttonColor = isNational
    ? colors.star
    : `linear-gradient(to bottom, #${primaryColor} 20%, #000 100%)`;
  const signUpButtonTextColor = isNational ? colors.abyss : colors.bone;

  return (
    <div
      className={classNames(styles.paywall, { [styles.gallery]: isGallery })}
    >
      <div className={styles.rIconContainer}>
        <RivalsSquareIcon
          backgroundFill={bulletColor}
          height="77"
          iconFill={colors.bone}
          width="97"
        />
      </div>
      <div className={styles.subscribe}>{title}</div>
      <div {...setData(DATA_PHILTER, "bullets")} className={styles.bullets}>
        <div
          {...setData(DATA_PHILTER, `${bullets.first}-bullets`)}
          className={styles.bulletRow}
        >
          <RivalsBullet fill={bulletColor} />
          <div className={styles.bullet}>{bullets.first}</div>
        </div>
        <div
          {...setData(DATA_PHILTER, `${bullets.second}-bullets`)}
          className={styles.bulletRow}
        >
          <RivalsBullet fill={bulletColor} />
          <div className={styles.bullet}>{bullets.second}</div>
        </div>
        <div
          {...setData(DATA_PHILTER, `${bullets.third}-bullets`)}
          className={styles.bulletRow}
        >
          <RivalsBullet fill={bulletColor} />
          <div className={styles.bullet}>{bullets.third}</div>
        </div>
      </div>
      <Link
        {...setData(DATA_PHILTER, "sign-up-button")}
        className={styles.linkButton}
        href={PATHS.SIGN_UP}
        style={{
          background: buttonColor,
          color: signUpButtonTextColor
        }}
      >
        {goBig}
      </Link>
      <Link
        {...setData(DATA_PHILTER, "sign-in-button")}
        className={classNames(styles.linkButton, styles.logInButton)}
        href={PATHS.SIGN_IN}
      >
        {logIn}
      </Link>
    </div>
  );
}

export default Paywall;
